import React,{useState, useEffect, useRef} from "react";
import DummyProfile from '../Assets/dummyprofile.png';
import UploadIcon from "../Assets/uploadIcon.svg";
import deleteIcon from "../Assets/deleteIcon.svg";
import { GetLocalStorage } from "../../../../Helpers/LocalStorage/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { FetchInstituteOwnersProfileData, UpdateInstituteOwnersProfileData } from "../../../../Actions/StudentA";
import { BaseUrl } from "../../../../Actions/Base";
import PhoneInput from "react-phone-input-2";
import { City, Country, State } from "country-state-city";
import { CountryOptions } from "../../../Institute/AddInstructor/Components/OptionsArr/OptionsArr";
import { SettingSelectList } from "../../../../Components/InputComps/InputComps";
import axios from "axios";
import SearchLocationByInputStudent from "../../../Institute/AddInstructor/Components/InstructorInfo/components/GooglePlacesApi/SearchLocationByInputStudent";
import { validatePhoneNumber, validateEmail } from "../../../../Components/ReuseableFunctions/ValidationFunctions";
import ReuseablePopup from "../../../../Components/ReuseablePopups/ReuseablePopup";
import errorMessageImage from "../Assets/errorMessage.png";
import SettingSearchLocationByInputStudent from "../../../Institute/AddInstructor/Components/InstructorInfo/components/GooglePlacesApi/SettingSearchLocationByInputStudent";

// const InstituteProfileSettings = ({}) => {
// return(
//     <div className="w-full bg-[#F8FAFA] rounded-[10px] flex flex-col gap-[10px] p-[20px]">

//         <div className="w-full flex justify-between items-center pb-[20px]"
//             style={{borderBottom: "1px solid #CECECE"}}>
//             <div className="w-[80px] h-[80px] rounded-full overflow-hidden"
//                 style={{border: "3px solid #2D2366"}}>
//                 <img src={DummyProfile} alt="DummyProfile" className="w-full h-full object-cover" />
//             </div>

//             <div>
//                 <button
//                     className="w-[127px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px] cursor-pointer"
//                     >
//                     Upload
//                 </button>
//             </div>
//         </div>

//         <div className="w-full flex justify-between items-center py-[20px]"
//             style={{borderBottom: "1px solid #CECECE"}}>
//             <div className="flex flex-col gap-[10px]">
//                 <p className="text-[20px] text-[#2D2366] font-bold">Name</p>
//                 <p className="text-[20px] text-[#2D2366]">James Smith</p>
//             </div>

//             <div>
//                 <button className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px] cursor-pointer">
//                    Edit
//                 </button>
//             </div>
//         </div>

//         <div className="w-full flex justify-between items-center py-[20px]"
//             style={{borderBottom: "1px solid #CECECE"}}>
//             <div className="flex flex-col gap-[10px]">
//                 <p className="text-[20px] text-[#2D2366] font-bold">Contacts</p>
//                 <p className="text-[20px] text-[#2D2366]">Phone: 0123123456789</p>
//                 <p className="text-[20px] text-[#2D2366]">Email: email@gmail.com</p>
//             </div>

//             <div>
//                 <button className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px] cursor-pointer">
//                    Edit
//                 </button>
//             </div>
//         </div>

//         <div className="w-full flex justify-between items-center py-[20px]"
//             style={{borderBottom: "1px solid #CECECE"}}>
//             <div className="flex flex-col gap-[10px]">
//                 <p className="text-[20px] text-[#2D2366] font-bold">Date of Birth</p>
//                 <p className="text-[20px] text-[#2D2366]">09/10/1998</p>
//             </div>

//             <div>
//                 <button
//                     disabled
//                     className={`w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] 
//                                 text-[#FFFFFF] text-[20px] cursor-not-allowed`}
//                                 style={{
//                                 background: '#625BA8 0% 0% no-repeat padding-box',
//                                 boxShadow: '0px 0px 6px #00000029',
//                                 opacity: 1,
//                                 }}
//                     >
//                     Edit
//                 </button>
//             </div>
//         </div>

//         <div className="w-full flex justify-between items-center py-[20px]"
//             style={{borderBottom: "1px solid #CECECE"}}>
//             <div className="flex flex-col gap-[10px]">
//                 <p className="text-[20px] text-[#2D2366] font-bold">Address</p>
//                 <p className="text-[20px] text-[#2D2366]">Country: Canada</p>
//                 <p className="text-[20px] text-[#2D2366]">Province: Ontario</p>
//                 <p className="text-[20px] text-[#2D2366]">City: Toronto</p>
//                 <p className="text-[20px] text-[#2D2366]">Postal Code: A1B 1A2</p>
//             </div>

//             <div>
//                 <button className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px] cursor-pointer">
//                    Edit
//                 </button>
//             </div>
//         </div>

//     </div>
// )
// }

const InstituteProfileSettings = () => {
  const [editField, setEditField] = useState(null);
  const [formData, setFormData] = useState({
    name: 'James Smith',
    phone: '0123123456789',
    email: 'email@gmail.com',
    dob: '09/10/1998',
    country: 'Canada',
    province: 'Ontario',
    city: 'Toronto',
    postalCode: 'A1B 1A2',
    Address:'',
    imgUrl:''
  });
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [isUpdatedPopup, setIsUpdatedPopup] = useState(false);
  const [isDeletingPopup, setIsDeletingPopup] = useState(false);
  const [tempImageFile, setTempImageFile] = useState(null);
  const [previousImageUrl, setPreviousImageUrl] = useState(formData.imgUrl);
  const [cities, setCities] = useState([]);
  const [errors, setErrors] = useState({});
  const [SelectedCoordinates, setSelectedCoordinates] = useState(null);
  const [isUpdationFailedPopup, setIsUpdationFailedPopup] = useState(false);
  const [errorMessageText, setErrorMessageText] = useState("Something Went Wrong");
  const fileInputRef = useRef();
  const tempImageFileRef = useRef(null);

  const [Err, setErr] = React.useState({});
  
  const Dispatch = useDispatch();

  const InstituteId = GetLocalStorage("UserInfo")?.Institute?.InstituteId;
  console.log("InstituteId in SchoolTimingsAndSchedule is:",InstituteId);

  const { InstituteOwnersProfileData } = useSelector((Store) => Store.StudentReducer);
  console.log("InstituteOwnersProfileData is:",InstituteOwnersProfileData)

  useEffect(() => {
    if(InstituteId){
        Dispatch(FetchInstituteOwnersProfileData(InstituteId))
    }
  }, [InstituteId]);

    useEffect(() => {
        const selectedCountry = formData?.country;
        console.log("selected country set in new location is:",selectedCountry)
        const selectedProvince = formData?.province;
        console.log("selected selectedProvince set in new location is:",selectedProvince)
        if (
        typeof selectedCountry === "string" &&
        typeof selectedProvince === "string"
        ) {
        const country = Country?.getAllCountries()?.find(
            (country) =>
            country?.name.toLowerCase() === selectedCountry?.toLowerCase()
        );
        if (country) {
            const states = State?.getStatesOfCountry(country?.isoCode);
            const selectedProvinceData = states?.find(
            (province) =>
                province.name.toLowerCase() === selectedProvince?.toLowerCase()
            );
            if (selectedProvinceData ) {
            console.log("Found Province: ", selectedProvinceData);
            const citiesData = City.getCitiesOfState(
                country?.isoCode,
                selectedProvinceData?.isoCode
            );
            setCities(citiesData);
            }
        }
        }
    }, [formData]);

    const ProvinceOptions = () => {
        let states = [];

        // Determine the country to use
    const countryName = formData?.country;

        if (typeof countryName  === "string") {
        let countries = Country?.getAllCountries();

        const country = countries?.find(
            (country) =>
            country?.name.toLowerCase() ===
            countryName.toLowerCase()
        );

        if (country) {
            states = State?.getStatesOfCountry(country?.isoCode);
            // console.log("country", states);
        }
        }

        console.log("States", states);
        return states?.map((country) => (
        <option value={country.name} key={country.isoCode}>
            {country?.name}
        </option>
        ));
    };

    const CityOptions = () => {
    return (
        cities &&
        cities?.map((city, index) => (
        <option value={city?.name} key={index}>
            {city?.name}
        </option>
        ))
    );
    };

    const fetchLocationData = async (postalCode) => {
        try {
            console.log("Fetching data for postal code:", postalCode);
            const response = await axios.get(
                "https://maps.googleapis.com/maps/api/geocode/json",
                {
                    params: {
                        address: postalCode,
                        key: "AIzaSyCWiF-rhJC5vG-_6akKZbSiJ1AIRxJe_mI", // Use your actual API key
                    },
                }
            );

            if (response.data.results.length > 0) {
                const location = response.data.results[0].address_components;
                console.log("Google Maps API response:", location);

                const country = location.find((comp) =>
                    comp.types.includes("country")
                )?.long_name || '';

                if (country !== "Canada") {
                    setErrors((prev) => ({ ...prev, postalCode: "Postal code must be from Canada" }));
                    return;
                } else {
                    setErrors((prev) => ({ ...prev, postalCode: "" }));
                }

                const state = location.find((comp) =>
                    comp.types.includes("administrative_area_level_1")
                )?.long_name || '';

                const city = location.find((comp) =>
                    comp.types.includes("locality")
                )?.long_name || '';

                setFormData((prev) => ({
                    ...prev,
                    country,
                    province: state,
                    city,
                }));
            }
        } catch (error) {
            console.error("Error fetching location data:", error);
            setErrors((prev) => ({ ...prev, postalCode: "Error fetching location data" }));
        }
    };

  // Map fetched profile data to formData
    useEffect(() => {
        if (InstituteOwnersProfileData && Object.keys(InstituteOwnersProfileData).length > 0) {
        setFormData({
            name: `${InstituteOwnersProfileData.FirstName?.trim() || ''} ${InstituteOwnersProfileData.LastName?.trim() || ''}`,
            phone: InstituteOwnersProfileData.ContactNumber || '',
            email: InstituteOwnersProfileData.Email || '',
            dob: InstituteOwnersProfileData.DateOfBirth || 'Not Applicable', // If you have a DOB field, use it here like InstituteOwnersProfileData.DOB
            country: InstituteOwnersProfileData.Country || '',
            province: InstituteOwnersProfileData.State || '',
            city: InstituteOwnersProfileData.City || '',
            postalCode: InstituteOwnersProfileData.PostalCode || '',
            Address: InstituteOwnersProfileData.Address || '',
            imgUrl: `${BaseUrl}/api/images/InstituteownerImages?url=${InstituteOwnersProfileData?.OwnerPicture || ''}`
        });
        }
    }, [InstituteOwnersProfileData]);

    useEffect(() => {
      if (formData.postalCode) {
          fetchLocationData(formData.postalCode);
      }
    }, [formData.postalCode]);
  

    const handleChange = (field, value) => {
        setFormData((prev) => ({
        ...prev,
        [field]: value,
        }));

        if (field === 'phone') {
          setErrors((prev) => ({
            ...prev,
            phone: validatePhoneNumber(value) ? '' : 'Invalid Phone Number',
          }));
        }
      
        if (field === 'email') {
          setErrors((prev) => ({
            ...prev,
            email: validateEmail(value) ? '' : 'Invalid email format',
          }));
        }
    };

    const handleCancel = () => {
        setEditField(null);
    };

    const handleUpdate = () => {
        // You can add API update logic here

        // Prevent update if there are validation errors
        if (errors.phone || errors.email) {
          console.warn("Update blocked due to validation errors.");
          return;
        }

        setEditField(null);

        Dispatch(UpdateInstituteOwnersProfileData(InstituteId, formData, 
          () => {
            console.log("Updated Successfully!");
            setIsUpdatedPopup(true)
        },
        (errorMessage) => {
          setErrorMessageText(errorMessage)
          setIsUpdationFailedPopup(true)
        }))
    };
      
    const handleDeleteImage = () => {
        setFormData((prev) => ({
          ...prev,
          imgUrl: "", // Clear image
        }));

        setIsDeletingPopup(false)
      };
    
    const handleToggleImageUpload = () => {
      if (!isUploadingImage) {
        setPreviousImageUrl(formData.imgUrl);
        setIsUploadingImage(true);
        // Reset the file input value
        fileInputRef.current.value = ''; // Reset the file input
        // Trigger file input click
        fileInputRef.current.click();
      } else {
        // Cancel upload and reset the state to previous image
        setFormData((prev) => ({
          ...prev,
          imgUrl: `${BaseUrl}/api/images/InstituteownerImages?url=${InstituteOwnersProfileData?.OwnerPicture}`,
        }));
        setTempImageFile(null);
        setIsUploadingImage(false);
      }
    };
    
    const handleImageSelection = (e) => {
      const file = e.target.files[0];
      if (file) {
        tempImageFileRef.current = file; // ✅ Immediate update
        const previewUrl = URL.createObjectURL(file);
        console.log("previewUrl is:",previewUrl)
        setFormData((prev) => ({
          ...prev,
          imgUrl: previewUrl,
        }));
      }
    
      // Clear input so same file can be reselected
      e.target.value = null;
    };
       
    const handleConfirmUpload = async () => {
      const file = tempImageFileRef.current;
      if (!file) {
        console.log("No file to upload.");
        return;
      }
    
      try {
        const formData = new FormData();
        formData.append("OwnerPicture", file);
    
        const response = await fetch(`${BaseUrl}/api/NewInstitute/updateOwnerPicture/${InstituteId}`, {
          method: "POST",
          body: formData,
        });
    
        const result = await response.json();
    
        if (response.ok) {
          // Save image URL to local state for UI display
          setFormData((prev) => ({
            ...prev,
            imgUrl: `${BaseUrl}/api/images/InstituteownerImages?url=${result.path}`,
          }));
    
          setIsUploadingImage(false);
          setTempImageFile(null);
          setIsUpdatedPopup(true)
          // alert("updated")
        } else {
          console.error("Upload failed:", result.error);
          alert("Upload failed:", result.error)
        }
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    };
      
  return (
    <div className="w-[95%] bg-[#F8FAFA] rounded-[10px] flex flex-col gap-[10px] p-[20px]">
      {/* Profile Image Upload */}
      <div
        className="w-full flex justify-between items-center pb-[20px]"
        style={{ borderBottom: '1px solid #CECECE' }}
      >
        <div
          className="w-[80px] h-[80px] rounded-full overflow-hidden"
          style={{ border: '3px solid #2D2366' }}
        >
          <img
                src={formData.imgUrl}
                alt="img"
                className="w-full h-full object-cover"
            /> 
        </div>
        <div className="flex items-center gap-[15px]">
            {isUploadingImage ? (
            <>
                <p onClick={handleToggleImageUpload} className="text-[20px] text-[#A1A3EF] cursor-pointer">
                Cancel
                </p>
                <button
                onClick={handleConfirmUpload}
                className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-white text-[20px] cursor-pointer"
                >
                Update
                </button>
            </>
            ) : (
            <>
                {/* <button
                // onClick={handleDeleteImage}
                onClick={() => setIsDeletingPopup(true)} // <-- Add this line
                className="w-[43px] h-[43px] flex justify-center items-center rounded-[9px] bg-[#F8F8F8] cursor-pointer"
                style={{ border: "1px solid #D7D7D7" }}
                >
                <img src={deleteIcon} alt="deleteIcon" />
                </button> */}
                <button
                onClick={handleToggleImageUpload}
                className="w-[127px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-white text-[20px] cursor-pointer"
                >
                <img src={UploadIcon} alt="UploadIcon" />
                Upload
                </button>
            </>
            )}
        </div>

        {/* ✅ Always present input */}
        <input
        ref={fileInputRef}
        type="file"
        accept="image/*"
        onChange={handleImageSelection}
        style={{ display: 'none' }}
        />

        {/* <div className="flex items-center gap-[15px]">
          <button className="w-[43px] h-[43px] flex justify-center items-center rounded-[9px] bg-[#F8F8F8] cursor-pointer"
            style={{
                border: "1px solid #D7D7D7"
            }}>
            <img src={deleteIcon} alt="deleteIcon" />
          </button> 
          <button className="w-[127px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-white text-[20px] cursor-pointer">
            <img src={UploadIcon} alt="UploadIcon" />
            Upload
          </button>
        </div> */}
      </div>

      {/* Name */}
        <div className="w-full flex justify-between items-center py-[20px]"
            style={{borderBottom: "1px solid #CECECE"}}>
            <div className="flex flex-col gap-[10px]">
                <p className="text-[20px] text-[#2D2366] font-bold">Name</p>
                <p className="text-[20px] text-[#2D2366]">{formData.name}</p>
            </div>

            <div>
                <button 
                disabled
                className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#DCDEF6] text-[#FFFFFF] text-[20px] cursor-not-allowed">
                   Edit
                </button>
            </div>
        </div>

      {/* Contacts */}

      <FieldSection
        label="Contacts"
        isEditing={editField === 'contacts'}
        onEdit={() => setEditField('contacts')}
        onCancel={handleCancel}
        onUpdate={handleUpdate}
        disableUpdate={Boolean(errors.phone || errors.email)} // New prop
        customContent={
            editField === 'contacts' ? (
            <>
            {/* Phone error above input */}
                {errors.phone && <p className="text-[#FF0000]">{errors.phone}</p>}
                <PhoneInput
                country="ca"
                value={formData.phone}
                onChange={(value) => handleChange('phone', value)}
                inputProps={{
                    name: "PhoneNumber",
                }}
                containerClass={"PhoneNumberInput"}
                inputClass={"CustomPhoneNumberInput"}
                specialLabel={"Phone Number *"}
                inputStyle={{
                    width: "100%",
                    height: "45px",
                }}
                />
                {/* Phone error above input */}
                {errors.email && <p className="text-[#FF0000] mb-1">{errors.email}</p>}
                <input
                value={formData.email}
                onChange={(e) => handleChange('email', e.target.value)}
                className="text-[18px] p-[10px] outline-none"
                style={{ border: "1px solid #E8E8E8" }}
                />
            </>
            ) : (
            <>
                <p className="text-[20px] text-[#2D2366]">Phone: {formData.phone}</p>
                <p className="text-[20px] text-[#2D2366]">Email: {formData.email}</p>
            </>
            )
        }
      />

      {/* Date of Birth (disabled) */}
      <FieldSection
        label="Date of Birth"
        isEditing={editField === 'dob'}
        onEdit={() => setEditField('dob')}
        onCancel={handleCancel}
        onUpdate={handleUpdate}
        customContent={
            editField === 'dob' ? (
            <input
                type="date"
                name="dob"
                value={formData.dob}
                onChange={(e) => handleChange('dob', e.target.value)}
                className="text-[18px] p-[10px] outline-none w-full rounded-md shadow-[4px_5px_6px_#00000029]"
                style={{ border: "1px solid #E8E8E8" }}
            />
            ) : (
            <p className="text-[20px] text-[#2D2366]">{formData.dob}</p>
            )
        }
    />

      {/* Address */}
      <FieldSection
        label="Address"
        isEditing={editField === 'Address'}
        onEdit={() => setEditField('Address')}
        onCancel={handleCancel}
        onUpdate={handleUpdate}
        customContent={
            editField === 'Address' ? (
            <>
                {/* Postal Code Input */}
                <input
                    type="text"
                    id="postalCode"
                    name="postalCode"
                    placeholder="A1A 1A1"
                    value={formData.postalCode}
                    onChange={(e) => handleChange("postalCode", e.target.value)}
                    className="text-[18px] p-[10px] outline-none"
                    style={{ border: "1px solid #E8E8E8" }}
                />
                {/* Country Select */}
                <SettingSelectList
                Id="Country"
                defaultValue=""
                Text="Country"
                OptionsArr={CountryOptions}
                State={formData.country}
                onChange={(e) => handleChange("country", e.target.value)}
                />

                {/* Province Select */}
                <SettingSelectList
                Id="Province"
                defaultValue=""
                Text="Province / Territory"
                OptionsArr={ProvinceOptions}
                State={formData.province}
                onChange={(e) => handleChange("province", e.target.value)}
                />

                {/* City Select */}
                <SettingSelectList
                Id="City"
                defaultValue=""
                Text="City"
                OptionsArr={CityOptions}
                State={formData.city}
                onChange={(e) => handleChange("city", e.target.value)}
                />

                {/* Address Search */}
                {/* <SearchLocationByInputStudent
                    InstructorData={formData}
                    setInstructorData={setFormData}
                    EnrollmentData={formData}
                    Err={Err?.Address}
                    setErr={setErr}
                    setSelectedCoordinates={setSelectedCoordinates}
                    newCountryPostalCode={formData?.country}
                    Id="Address"
                    addressType="Address"
                /> */}
                <SettingSearchLocationByInputStudent
                            InstructorData={{ Address: formData.Address }} // Pass Address data
                            setInstructorData={setFormData }
                            EnrollmentData={{
                                StudentData: {
                                    Country: formData.country, // Use selected country for restrictions
                                },
                            }}
                            setSelectedCoordinates={setSelectedCoordinates} // Update lat/lng
                            newCountryPostalCode={formData.country}
                            Id="Address"
                            addressType="Address"
                        />
            </>
            ) : (
            <>
                <p className="text-[20px] text-[#2D2366]">Postal Code: {formData.postalCode}</p>
                <p className="text-[20px] text-[#2D2366]">Country: {formData.country}</p>
                <p className="text-[20px] text-[#2D2366]">Province: {formData.province}</p>
                <p className="text-[20px] text-[#2D2366]">City: {formData.city}</p>
                <p className="text-[20px] text-[#2D2366]">Address: {formData.Address}</p>
            </>
            )
        }
      />

      {isUpdatedPopup && (
        <ReuseablePopup
          setShowPopup={setIsUpdatedPopup}
          heading="Congratulations !!"
          text="Changes saved successfully."
          btnText="Done"
          onClick={() => setIsUpdatedPopup(false)} // <-- Add this line
          imageSrc={require("../Assets/SuccessAssets.svg").default} // ✅ Dynamic image source
        />
      )}

      {isDeletingPopup && (
        <ReuseablePopup
          setShowPopup={setIsDeletingPopup}
          heading="Delete"
          text="Are you sure you want to delete the image?"
          btnText="Delete"
          onClick={handleDeleteImage} // <-- Add this line
          imageSrc={require("../Assets/DeletePopup.svg").default} // ✅ Dynamic image source
        />
      )}

      {isUpdationFailedPopup && (
          <ReuseablePopup
          setShowPopup={setIsUpdationFailedPopup}
          heading="Oops!"
          text={errorMessageText}
          btnText="Back"
          onClick={() => setIsUpdationFailedPopup(false)} // <-- Add this line
          imageSrc={errorMessageImage} // ✅ Dynamic image source
          />
      )}

    </div>
  );
};

const FieldSection = ({ label, value, isEditing, onEdit, onCancel, onUpdate, onChange, disableUpdate, customContent, disabled }) => {
  return (
    <div className="w-full flex justify-between items-center py-[20px]" style={{ borderBottom: '1px solid #CECECE' }}>
      <div className="flex flex-col gap-[10px]">
        <p className="text-[20px] text-[#2D2366] font-bold">{label}</p>
        {customContent || (
          isEditing ? (
            <input value={value} onChange={onChange} className="text-[20px] text-[#2D2366] border p-1" />
          ) : (
            <p className="text-[20px] text-[#2D2366]">{value}</p>
          )
        )}
      </div>

      <div className="flex items-center gap-[20px]">
        {disabled ? (
          <button
            disabled
            className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] text-white text-[20px] cursor-not-allowed"
            style={{
              background: '#625BA8 0% 0% no-repeat padding-box',
              boxShadow: '0px 0px 6px #00000029',
              opacity: 1,
            }}
          >
            Edit
          </button>
        ) : isEditing ? (
          <>
            <p
              onClick={onCancel}
              className="text-[20px] text-[#A1A3EF] cursor-pointer"
            >
              Cancel
            </p>
            <button
              onClick={onUpdate}
              // className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-white text-[20px] cursor-pointer"
              className={`w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-white text-[20px] cursor-pointer ${disableUpdate ? 'cursor-not-allowed' : ''}`}
            >
              Update
            </button>
          </>
        ) : (
          <button
            onClick={onEdit}
            className="w-[80px] h-[42px] flex justify-center items-center gap-[10px] rounded-[8px] bg-[#A1A3EF] text-white text-[20px] cursor-pointer"
          >
            Edit
          </button>
        )}
      </div>
    </div>
  );
};


export default InstituteProfileSettings;
